export const DEFAULT_VIDEO_VARIANT_NAME = 'default';
